export const formatCurrency = (centsAmount) => {
  return '$' + (centsAmount/100).toFixed(2)
}

